const paymentCompletionDefaultItems = [
  {
    bgColor: '#7FCFEC',
    href: '/radio/sports/',
    subtitle1: 'Every game.',
    subtitle2: 'Every replay. Every league.',
    image: null,
    title: 'SPORTS.',
  },
  {
    bgColor: '#fec25a',
    href: '/radio/News--Talk-c57922/',
    subtitle1: 'Left. Right. Center.',
    subtitle2: 'Sharp journalism. Clear context.',
    image: null,
    title: 'NEWS.',
  },
  {
    bgColor: '#d24a7a',
    href: '/radio/music/',
    subtitle1: 'Every genre.',
    subtitle2: 'Every song. Commercial-free.',
    image: null,
    title: 'MUSIC.',
  },
  {
    bgColor: '#14d8cc',
    href: '/podcasts/',
    subtitle1: 'Binge-worthy.',
    subtitle2: 'Trending. Commercial-free.',
    image: null,
    title: 'PODCASTS.',
  },
];

export default paymentCompletionDefaultItems;
